export const tra =[
	{
		"constant": false,
		"inputs": [
			{
				"name": "_receiver",
				"type": "address"
			}
		],
		"name": "sendss",
		"outputs": [],
		"payable": true,
		"stateMutability": "payable",
		"type": "function"
	}
];